import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { ChargePointsConnectorsColumn } from './charge-points-connectors.column';
import { ChargePointsLastMessageColumn } from './charge-points-last-message.column';
import { ChargePointsNameColumn } from './charge-points-name.column';
import { ChargePointsQrCodeColumn } from './charge-points-qr-code.column';
import { ChargePointsReasonsColumn } from './charge-points-reasons.column';
import { ChargePointsSiteColumn } from './charge-points-site.column';

// /////////////////////////////////////////////////////////////////////////////
// DISPLAYING
// /////////////////////////////////////////////////////////////////////////////

export const chargePointsColumnHelper =
  createColumnHelper<GatewayChargePointInMaintenanceModel>();

export const CHARGE_POINTS_COLUMN_LIST: ColumnDef<
  GatewayChargePointInMaintenanceModel,
  any
>[] = [
  chargePointsColumnHelper.display(ChargePointsQrCodeColumn),
  chargePointsColumnHelper.accessor('name', ChargePointsNameColumn),
  chargePointsColumnHelper.accessor('location', ChargePointsSiteColumn),
  chargePointsColumnHelper.accessor('channels', ChargePointsConnectorsColumn),
  chargePointsColumnHelper.accessor('reasons', ChargePointsReasonsColumn),
  chargePointsColumnHelper.accessor(
    'lastHeartbeatTime',
    ChargePointsLastMessageColumn,
  ),
];
